import {FC} from 'react';
import remarkGfm from 'remark-gfm';
import Markdown from 'react-markdown';

interface IProps {
  text: string;
}

const MarkdownContentFC: FC<IProps> = ({text}) => {
  return (
    <Markdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({...props}) => {
          // @ts-ignore
          return <a {...props} target="_blank" rel="noopener noreferrer" />;
        },
        table({className, children}) {
          return (
            <div className={'table-container'}>
              <table className={className}>{children}</table>
            </div>
          );
        }
      }}
    >
      {text}
    </Markdown>
  );
};

export const MarkdownContent = MarkdownContentFC;
